// extracted by mini-css-extract-plugin
export var cardPic = "carouselPic-module--cardPic--tWECD";
export var swiperContainer = "carouselPic-module--swiperContainer--fSuiR";
export var wrapper = "carouselPic-module--wrapper--8JSiI";